import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { DecimalPipe, NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserArtistApiService } from '../../../services/API/apiServive/user-artist-api.service';
import { PaymentApiService } from '../../../services/API/apiPaymentService/payment-api.service';
import { ButtonComponent } from "../button/button.component";
import { CanvasPreviewComponent } from "../canvas-preview/canvas-preview.component";
import { Router } from '@angular/router';
import { PopupService } from '../../../services/popup/popup.service';
import { PaymentConfirmationComponent } from '../../../modal/payment-confirmation/payment-confirmation.component';
import { UserProfileService } from '../../../services/API/user-profile.service/user-profile.service';

@Component({
  selector: 'app-make-payment',
  standalone: true,
  imports: [FormsModule, NgIf, ButtonComponent, CanvasPreviewComponent, CanvasPreviewComponent, DecimalPipe],
  templateUrl: './make-payment.component.html',
  styleUrl: './make-payment.component.scss',
  animations: [
    trigger('slideInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
        })
      ),
      state(
        'out',
        style({
          transform: 'translateX(100%)',
        })
      ),
      transition('out => in', [animate('300ms ease-in')]),
      transition('in => out', [animate('300ms ease-out')]),
    ]),
  ],
})
export class MakePaymentComponent implements OnInit {
  @Input() art: any = {
    artName: '',
    artPrice: 0,
    artUploadUrl: '',
    artThumbnailUrl: '',
    categoryList: [],
    city: '',
    country: '',
    description: '',
    keywords: '',
    placeName: '',
    region: '',
    seasonName: '',
    signature: '',
  };

  @Input() artId!: string; // ID of the art to be edited
  @Output() close = new EventEmitter<void>();
  @Output() artDeleted = new EventEmitter<void>();
  slideState = 'out';
  availableCategories: string[] = [
    'Nature & Landscapes',
    'Architecture',
    'Astrophotography',
    'Sports',
    'Abstract',
    'People',
    'Paintings',
    'Urban & Cities',
    'Animal & Wildlife',
    'Street Photography',
    'Videos',
    'Kids Experiences',
  ];

  constructor(
    private toaster: ToastrService,
    private apiService: UserArtistApiService,
    private apiPayment: PaymentApiService,
    private router: Router,
    private popupService: PopupService,
    private userProfileService: UserProfileService,
  ) { }

  // Trigger sliding in
  ngOnInit(): void {
    this.getCards();
    setTimeout(() => {
      this.slideState = 'in';
    }, 0);
  }

  closeModal(): void {
    this.slideState = 'out';
    setTimeout(() => this.close.emit(), 300); // Wait for the slide-out animation to finish
  }

  paymentLink: string = '';

  openConfirmationPopup(): void {
    if (!this.hasSavedCards) {
      this.subscribeInAppPurchaseArtsSubscription();
      return;
    }
    this.popupService.open(PaymentConfirmationComponent, {
      totalPayable: (this.art?.price || this.art?.artPrice)
    })
      ?.subscribe({
        next: (res) => {
          if (res) {
            this.popupService.close();
            this.subscribeInAppPurchaseArtsSubscription(res.payload?.paymentMethodId || null);
          }
        }
      });
  }


  hasSavedCards = true;
  getCards(): void {
    this.userProfileService.getSavedCards()
      .subscribe({
        next: (res: any) => {
          const data = [...res.data];
          this.hasSavedCards = !!data.length;
        },
        complete: () => {
        },
      })
  }

  subscribeInAppPurchaseArtsSubscription(paymentMethodId: string | null = null): void {
    this.apiPayment
      .subscribeInAppPurchaseArtsSubscription([this.art.id], paymentMethodId)
      .subscribe({
        next: (res) => {
          if (res.message.includes("Already Purchase")) {
            this.toaster.warning(res.message);
            return;
          }
          this.paymentLink = res.data;
          if (this.paymentLink.includes("sub_")) {
            this.router.navigate([`/payment_success`], { queryParams: { stripeSubscriptionId: this.paymentLink } });
            return;
          }
          if (this.paymentLink) {
            this.triggerClick()
          }
        },
      });
  }

  triggerClick() {
    const link = document.querySelector('#myLink') as HTMLAnchorElement;
    if (link && this.paymentLink) {
      link.href = this.paymentLink; // Ensure the `href` is dynamically updated.
      link.click();
    } else {
      console.error('Payment link is not ready.');
    }
  }

  onSave(): void {
    // const apiUrl = `http://44.198.219.138:6060/api/v1/deleteArtDetailByArtDetailId/${this.artId}`;
    this.apiService.deleteArt(this.artId).subscribe({
      next: (res: any) => {
        if (res.message == 'Subscribed artwork cannot be deleted') {
          this.toaster.info('Subscribed artwork cannot be deleted');
        } else {
          this.toaster.success(res.message || 'Artwork delete successfully!');
        }
        this.artDeleted.emit();
        this.closeModal();
      },
      error: (error) => {
        console.error('Failed to update artwork details:', error);
        this.toaster.success(
          error.message ||
          error.error.message ||
          'Failed to delete art. Please try again.'
        );
        // alert('Failed to update art details. Please try again.');
      },
    });
  }
}
